import React from 'react';
import { PUBLIC_URL } from '../utils/const';
import Layout from '../layouts/Layout';
import { useTranslation } from 'react-i18next';
import { BlogProperties, RouteWrapper, getBlogForLanguage } from 'reactyll';
import { blogs } from '../_blog/routes';
import { ExtraProperties } from '../components/BlogTemplate';
import { sortBlogsByDate } from '../utils/blog';
import { Container, Title, Text, Card, Stack, Group } from '@mantine/core';
import Seo from '../components/Seo';

const InnerBlog: React.FC = () => {
    const { t, i18n } = useTranslation();

    return (
        <>
            <Seo
                title={t('blog.meta.og_title')}
                description={t('blog.meta.description')}
                path="/blog"
            />
            <Container size="md">
                <Group mt="md" mb="lg" justify="center">
                    <Stack justify="center" align="center">
                        <Title order={1} fw={200}>Blog</Title>
                    </Stack>
                </Group>
            </Container>

            <Container size="md" py="xl">
                {sortBlogsByDate(blogs as RouteWrapper<ExtraProperties>).map((data) => {
                    return [getBlogForLanguage(data, i18n.language, "en") as BlogProperties & ExtraProperties].map((blog) => (
                        <Card
                            shadow="sm"
                            withBorder
                            key={blog.url}
                            component="a"
                            href={`${PUBLIC_URL}${blog.url}`}
                            mb="md"
                            padding="md"
                            className='blog-card'
                        >
                            <Title order={2}>{blog.title}</Title>
                            <Title order={3} c="dimmed" mt="xs" fw={300} fz="lg">
                                {blog.headline}
                            </Title>
                        </Card>
                    ))
                })}
            </Container>
        </>
    );
};

const Blog: React.FC = () => {
    return <Layout onlyRequired={false}>
        <InnerBlog />
    </Layout>;
};

export default Blog;